import { TypeGame } from '../../../constants/game';
import { StatisticsOption } from '../../Statistics/types';
import { IOptions, IUserWord } from '../types';

export const NewDifficultWord = (): IUserWord => ({
  difficulty: '0',
  optional: {
    difficult: true,
    learned: false,
    sprint: { right: 0, wrong: 0 },
    audio: { right: 0, wrong: 0 },
  },
});

export const NewLearnWord = (): IUserWord => ({
  difficulty: '0',
  optional: {
    difficult: false,
    learned: true,
    sprint: { right: 0, wrong: 0 },
    audio: { right: 0, wrong: 0 },
  },
});

export const updateDiffWord = (userWord: IUserWord): IUserWord => {
  return {
    ...userWord,
    optional: { ...userWord.optional, difficult: true, learned: false },
  };
};

export const updateLearnWord = (userWord: IUserWord): IUserWord => {
  return {
    ...userWord,
    optional: { ...userWord.optional, difficult: false, learned: true },
  };
};

export enum GameOptions {
  CORRECT = 'correct',
  WRONG = 'wrong',
}
export const updateUserWordsOptions = (
  option: StatisticsOption,
  userWord: IUserWord,
  gameOption: GameOptions
) => {
  const updateUserWords = { ...userWord };

  switch (option) {
    case StatisticsOption.AUDIO:
      if (gameOption === GameOptions.CORRECT) {
        updateUserWords.optional.difficult = false;
        updateUserWords.optional.learned = true;
        updateUserWords.optional.audio.right += 1;
      }
      if (gameOption === GameOptions.WRONG) {
        updateUserWords.optional.difficult = true;
        updateUserWords.optional.learned = false;
        updateUserWords.optional.audio.wrong += 1;
      }
      break;
    case StatisticsOption.SPRINT:
      if (gameOption === GameOptions.CORRECT) {
        updateUserWords.optional.difficult = false;
        updateUserWords.optional.learned = true;
        updateUserWords.optional.sprint.right += 1;
      }
      if (gameOption === GameOptions.WRONG) {
        updateUserWords.optional.difficult = true;
        updateUserWords.optional.learned = false;
        updateUserWords.optional.sprint.wrong += 1;
      }
      break;
    default:
      break;
  }
  return updateUserWords;
};

export const newGameWords = (option: StatisticsOption, gameOption: GameOptions) => {
  const defaultOptions: IUserWord = {
    difficulty: '0',
    optional: {
      difficult: false,
      learned: true,
      sprint: { right: 0, wrong: 0 },
      audio: { right: 0, wrong: 0 },
    },
  };
  switch (option) {
    case StatisticsOption.AUDIO:
      if (gameOption === GameOptions.CORRECT) {
        // return {
        //   difficulty: '0',
        //   optional: {
        //     difficult: false,
        //     learned: true,
        //     sprint: { right: 0, wrong: 0 },
        //     audio: { right: 1, wrong: 0 },
        //   },
        // };
        defaultOptions.optional.difficult = false;
        defaultOptions.optional.learned = true;
        defaultOptions.optional.audio.right += 1;
      }
      if (gameOption === GameOptions.WRONG) {
        // return {
        //   difficulty: '0',
        //   optional: {
        //     difficult: false,
        //     learned: true,
        //     sprint: { right: 0, wrong: 0 },
        //     audio: { right: 0, wrong: 1 },
        //   },
        // };
        defaultOptions.optional.difficult = true;
        defaultOptions.optional.learned = false;
        defaultOptions.optional.audio.wrong += 1;
      }
      break;
    case StatisticsOption.SPRINT:
      if (gameOption === GameOptions.CORRECT) {
        // return {
        //   difficulty: '0',
        //   optional: {
        //     difficult: false,
        //     learned: true,
        //     sprint: { right: 1, wrong: 0 },
        //     audio: { right: 0, wrong: 0 },
        //   },
        // };
        defaultOptions.optional.difficult = false;
        defaultOptions.optional.learned = true;
        defaultOptions.optional.sprint.right += 1;
      }
      if (gameOption === GameOptions.WRONG) {
        // return {
        //   difficulty: '0',
        //   optional: {
        //     difficult: false,
        //     learned: true,
        //     sprint: { right: 0, wrong: 1 },
        //     audio: { right: 0, wrong: 0 },
        //   },
        // };
        defaultOptions.optional.difficult = true;
        defaultOptions.optional.learned = false;
        defaultOptions.optional.sprint.wrong += 1;
      }
      break;
  }
  return defaultOptions;
};
